import { Text } from '@ui/atoms';
import { replaceKeysWithValues } from '@helpers/miscelleanous';
import { brandName } from '@helpers/constants';
import texts from '@components/FooterAppDownload/en.json';
import Button from '@ui/atoms/design-system/Button';
import useWindowDimensions from '@hooks/useWindowDimensions';

const AppDownloadLoggedIn = ({ handleOnClick, ButtonPrefixComponent, buttonText }) => {
    const { width } = useWindowDimensions();
    return (
        <div className="flex justify-between md:justify-center items-center gap-4 md:gap-6 text-basicWhite border-gray-300 border-b-[0.5px] xl:border-none  pb-6 xl:pb-0">
            <Text
                className="p5-semibold md:p4-semibold text-center"
                content={replaceKeysWithValues(texts?.DownloadBrandApp, {
                    '{brand}': brandName,
                })}
            />
            <Button
                buttonType="tertiary"
                buttonSize={width < 768 ? "extraSmall": "small"}
                buttonText={buttonText}
                className="!rounded-full"
                prefixComponent={<ButtonPrefixComponent />}
                onClick={handleOnClick}
            />
        </div>
    );
};

export default AppDownloadLoggedIn;
